import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { Button, FlexBox } from '@eltoro-ui/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faPaperclip } from '@fortawesome/pro-light-svg-icons';
import notTrestle from 'assets/Images/notTrestle.svg';

import './MobileCreativeStep.scss';
import { sendLinkViaEmail } from 'Requests/Request_Methods/campaignMethods';

const MobileCreativeStep = () => {
  const history = useHistory();
  const { campaignId } = useParams<{ campaignId: string }>();

  const sendLink = () => {
    sendLinkViaEmail(campaignId)
      .then(res => {
        toast.success('Link sent successfully!');
      })
      .catch(err => {
        if ('detail' in err) toast.error(err.detail);
        else toast.error('Failed to send the link.');
      });
  };

  const copyLink = () => {
    const text = document.getElementById('copy-link-input') as HTMLInputElement;
    if (!text) return;
    text.select();
    text.setSelectionRange(0, 99999999);
    navigator.clipboard
      .writeText(text.value)
      .then(() => {
        toast.success('Link copied!');
      })
      .catch(err => {
        toast.error('Failed to copy the link.');
      });
  };
  return (
    <FlexBox UNSAFE_className="CreativeContainer" flexDirection="column" alignItems="flex-start">
      <button onClick={() => history.push('/dashboard')} className="back_btn">
        <FontAwesomeIcon icon={faChevronLeft} style={{ fontSize: '24px' }} />
      </button>
      <FlexBox
        flexDirection="column"
        justifyContent="space-between"
        alignItems="center"
        UNSAFE_className="landing_content"
      >
        <FlexBox
          UNSAFE_className="illustartion_wrapper"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap="8px"
        >
          <img src={notTrestle} alt="mls-illustartion" className="mls-illustartion" />
          <div>
            <h3 className="heading">Saved and Safe! Time to Switch to a Bigger Screen.</h3>
            <p className="desc">
              We've saved your progress! Grab a bigger screen when you're ready to keep building
              your campaign.
            </p>
          </div>
        </FlexBox>
        <FlexBox
          flexDirection="column"
          alignItems="center"
          UNSAFE_className="action_btns"
          gap="16px"
        >
          <Button kind="primary" size="l" weight="bold" onClick={sendLink}>
            Send me this link via email
          </Button>

          <input
            type="text"
            value={`${window.location.origin}${history.location.pathname}`}
            id="copy-link-input"
            style={{ display: 'none' }}
          />
          <Button
            kind="link"
            size="l"
            weight="bold"
            iconLeft={<FontAwesomeIcon icon={faPaperclip} />}
            onClick={copyLink}
          >
            Copy draft campaign link
          </Button>
        </FlexBox>
      </FlexBox>
    </FlexBox>
  );
};

export default MobileCreativeStep;
